<template>
  <div class="navbar-container">
    <!-- 侧边栏切换按钮，控制侧边栏显示、隐藏 -->
    <SideTrigger :is-collapse="isCollapse" @toggleClick="toggleClick" class="side-trigger-container" />

    <!-- 面包屑导航，显示当前页面 -->
    <Breadcrumb class="breadcrumb-container" :breadList="breadList" />

    <!-- 右侧功能菜单 -->
    <ul class="right-menu">

      <!-- 动态添加的音频播放控件 -->
      <li v-if="audioUrl" class="audio-container">
        <audio ref="audioPlayer" controls :src="audioUrl" class="custom-audio"></audio>
      </li>

      <li @click="fullScreenHandel">
        <el-tooltip content="全屏" effect="dark" placement="bottom">
          <svg-icon icon-class="fullscreen" />
        </el-tooltip>
      </li>

      <li>
        <el-dropdown trigger="click" class="profile-container">
          <div class="profile-wrapper">
            <img style="width: 30px;height: 30px" :src="loginUser.user_profile" alt="">
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="toPathHandle('/system/aboutMe')">关于我</el-dropdown-item>
            <el-dropdown-item divided @click.native="logoutHandle">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
  </div>
</template>

<script>
import SideTrigger from '/src/components/SideTrigger/SideTrigger'
import Breadcrumb from '/src/components/Breadcrumb/Breadcrumb'
import screenfull from 'screenfull'

import { mapMutations } from 'vuex'
import { appMutation, userMutation } from "../../../../store/mutation-types";
import current from "element-ui/packages/table/src/store/current";

export default {
  name: "Navbar",
  props: {
    breadList: {
      type: Array,
      default: () => [],
    }
  },
  components: {
    SideTrigger,
    Breadcrumb,
  },
  data() {
    return {
      audioUrl: localStorage.getItem('audioUrl') || '' // 初始化时从 localStorage 读取
    };
  },
  computed: {
    isCollapse() {
      return this.$store.state.app.sidebar.isCollapse;
    },
    loginUser() {
      return this.$store.state.user.loginUserInfo;
    }
  },
  mounted() {
    // 监听 localStorage 的变化
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听
    window.removeEventListener('storage', this.handleStorageChange);
  },
  methods: {
    ...mapMutations([
      appMutation.TOGGLE_SIDEBAR,
      userMutation.CLEAR_TOKEN,
      appMutation.REMOVE_ALL_TAGS,
    ]),

    // 监听 storage 中 audioUrl 的变化
    handleStorageChange(event) {
      console.log(event, 'event', 111111)
      console.log(event.key, 'event', 222222)

      let audioUrl = localStorage.getItem('audioUrl')
      let currentAudioUrl = localStorage.getItem('currentAudioUrl')
      if (currentAudioUrl != audioUrl) {
        localStorage.setItem('currentAudioUrl', audioUrl)
        this.audioUrl = audioUrl
        this.$nextTick(() => {
          const audioPlayer = this.$refs.audioPlayer;
          if (audioPlayer) {
            console.log(1111111122)
            audioPlayer.play();  // 自动播放音频
          }
        });
      }
    },

    toPathHandle(url) {
      this.$router.push(url);
    },

    async logoutHandle() {
      /**
       * 1、清除所有本地缓存中的信息 token、userInfo等等
       * 2、跳转到登录页
       */
      console.log('退出登录');
      await this.$store.dispatch('clearAll');
      setTimeout(function () {
        window.location.href = window.location.origin + '/#/login'
      }, 200)
    },

    toggleClick() {
      this[appMutation.TOGGLE_SIDEBAR]();
    },

    fullScreenHandel() {
      if (!screenfull.enabled) {
        this.$message({
          message: 'your browser cannot work',
          type: 'warning'
        });
        return false;
      }
      screenfull.toggle();
    }
  }
}
</script>

<style scoped lang="scss">
@import "./Navbar";

.audio-container {
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中（可选） */
  height: 100%; /* 让父容器占据可用高度 */
}

.custom-audio {
  height: 30px; /* 自定义的播放器高度 */
}

</style>
